export default "__VITE_ASSET__BRBoNqKg__"